import { lazy } from "react"
import type { FormDateField as FormDateFieldCmp } from "./FormDateField"

export const FormDateField = lazy(() =>
  import("./FormDateField").then((module) => ({
    default: module.FormDateField,
  })),
) as typeof FormDateFieldCmp
